import React from 'react'
import styled from 'styled-components'

const TagItem = styled.span`
padding: 2px 15px;
background-color: var(--primaryColor);
border-radius: 24px;
color: white;
font-size: 13px;
margin-right: 6px;
margin-bottom: 11px;
text-transform: capitalize;
font-weight: 500;
cursor: pointer;
:hover{
    background-color: var(--darkColor);
}
`;

export default function Tag(props) {
    return (
        <TagItem>
            {props.text}
        </TagItem>
    )
}
